import { render, staticRenderFns } from "./ChannelTalk.vue?vue&type=template&id=32095eb0&scoped=true"
import script from "./ChannelTalk.vue?vue&type=script&lang=js"
export * from "./ChannelTalk.vue?vue&type=script&lang=js"
import style0 from "./ChannelTalk.vue?vue&type=style&index=0&id=32095eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32095eb0",
  null
  
)

export default component.exports